import { request } from "sats-connect";
import { fetchChallenge, postChallengeResponse } from "../auth";



export const loginWithXverse = async () => {
    try {
        const response = await request('wallet_connect', null);
        // console.log('Connected to Xverse wallet:', response);
        let result = response.result;
        if (response.status === 'success') {
            const address = result.addresses.find(
                (address) => address.purpose === "payment"
            )?.address;



            const challenge = await fetchChallenge(address);
            console.log("Challenge:", challenge);

            const signature = await signMessageWithXverse(
                address,
                challenge,
            );
            console.log("Signature:", signature);

            const response = await postChallengeResponse({
                address,
                message: challenge,
                signature,
            });
            if (!response.token) {
                throw new Error('No auth token received');
            }
            console.log("Response:", response.token);
            return {
                address,
                isConnected: true,
                token: response.token,
            };

        } else {
            throw response.error;
        }
    } catch (err) {
        throw err;
    }
};



export const signMessageWithXverse = async (address, message) => {

    try {
        const response = await request("signMessage", {
            address,
            message,
        });
        if (response.status === "success") {
            console.log("response", response);
            return response.result.signature;
            // handle success response
        } else {
            throw response.error;
        }
    } catch (err) {
        throw err;
    }
};





export const getXverseWalletAndProvider = async () => {
    try {
        const response = await request('wallet_connect', null);
        // console.log('Connected to Xverse wallet:', response);
        let result = response.result;
        if (response.status === 'success') {
            const response = result.addresses.find(
                (address) => address.purpose === "payment"
            )
            console.log("response", response);
            const address = response?.address;
            const publicKey = response?.publicKey;
            return {
                address,
                publicKey,
            };

        } else {
            throw response.error;
        }
    } catch (err) {
        throw err;
    }
};
